import React, { useContext } from 'react'
import { FaCircle, FaMinusCircle } from 'react-icons/fa'
import { styled, Button } from '@tools/wr-catalog-base'
import { hasCustomizeThisPathTab } from '@utils/product-utils'
import { ProductViewContext } from './index'

function AddToSOW(props) {
  const { addedToCart, addButtonLabel, addedButtonLabel, ...rest } = props
  const { isSuccessPath } = useContext(ProductViewContext)
  if (isSuccessPath && !hasCustomizeThisPathTab(props.product)) {
    rest.disabled = true
  }
  return (
    <Button type="button" {...rest}>
      {addedToCart ? (
        <>
          <FaCircle size={15} className="white" />
          <FaMinusCircle size={14} className="red" />
          {addedButtonLabel}
        </>
      ) : (
        addButtonLabel
      )}
    </Button>
  )
}

const FinalExport = styled(AddToSOW)`
  background-color: ${({ theme, addedToCart }) => (addedToCart ? theme.palette.primary : '#0099b3')};
  svg {
    position: absolute;
    top: -6px;
    left: -6px;
    &.white {
      color: white;
    }
    &.red {
      color: red;
    }
  }
`
FinalExport.Disabled = function AddToSOWDisabled(props) {
  return <FinalExport {...props} disabled />
}

export default FinalExport
